import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GeotabApiService {
  public credentials = new BehaviorSubject(JSON.parse(sessionStorage.getItem('rideview:credentials')));

  constructor(private httpClient: HttpClient) {}
  public getLoginData(): Observable<any> {
    const { userName = '', sessionId = '', database = '' } = this.credentials.getValue() || {};
    return this.httpClient.post('https://my.geotab.com/apiv1', {
      method: 'Get',
      params: {
        typeName: 'User',
        search: {
          name: userName,
        },
        credentials: {
          database: database,
          userName: userName,
          sessionId: sessionId,
        },
      },
    });
  }
}
